var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarScheduledOldDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.385 3.922a2.153 2.153 0 0 0-2.153-2.153H2.653A2.153 2.153 0 0 0 .5 3.922v9.307c0 1.19.964 2.153 2.153 2.153h10.58c1.189 0 2.152-.964 2.152-2.153V3.922z",
    stroke: "#22272A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22272A",
    strokeLinecap: "round",
    d: "M4.829.5v2.538M11.057.5v2.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22272A",
    d: "M4 7.875h1.75v-1.75H4zM4 11.5h1.75V9.75H4zM7.125 7.875h1.75v-1.75h-1.75zM7.125 11.5h1.75V9.75h-1.75zM10.25 7.875H12v-1.75h-1.75zM10.25 11.5H12V9.75h-1.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarScheduledOldDate);
export default __webpack_public_path__ + "static/media/calendar-scheduled_oldDate.5c2dc60ac69311dc4b74cfa3a71611c7.svg";
export { ForwardRef as ReactComponent };